import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {ServerResponseHandler} from 'src/components/server-response-handler';
import {ACCESS_RIGHTS} from 'src/hooks/access-rights';

import {ManageEntitlementsHeader} from '../../components/manage-entitlements-header';
import {ManageEntitlementsHeaderButtons} from '../../components/manage-entitlements-header-buttons';
import {MANAGE_ENTITLEMENTS_TABS, ManageEntitlementsTabs} from '../../components/manage-entitlements-tabs';
import {manageEntitlementsLoadingContainer} from '../../manage-entitlements.module.styl';
import {DATASET_NAVIGATION_STATE} from '../../utils';

import {DatasetEntitlementsTab} from './dataset-entitlements-tab';
import {datasetEntitlementsStateActions} from './slices/dataset-entitlements-state.slice';
import {datasetEntitlementsActions} from './slices/dataset-entitlements.slice';

import type {AccessRight} from 'src/hooks/access-rights/constants';

const SECTION_NAME = 'dataset-entitlements';

export const DatasetEntitlements = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(datasetEntitlementsActions.clearData());
            dispatch(datasetEntitlementsStateActions.clearData());
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ServerResponseHandler
            serverError={null}
            accessRight={ACCESS_RIGHTS.MANAGE_ENTITLEMENTS as AccessRight}
            sectionName={SECTION_NAME}>
            <>
                <ManageEntitlementsHeader
                    title="Dataset Entitlements"
                    buttonsBlock={<ManageEntitlementsHeaderButtons navigationState={DATASET_NAVIGATION_STATE}/>}
                />
                <ManageEntitlementsTabs activeTab={MANAGE_ENTITLEMENTS_TABS.DATASET_ENTITLEMENTS}/>
                <div className={manageEntitlementsLoadingContainer}>
                    <DatasetEntitlementsTab/>
                </div>
            </>
        </ServerResponseHandler>
    );
};
